module.exports = __webpack_public_path__ + "static/media/bg.58fff247.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bg.svg
// module id = 2046
// module chunks = 0